import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.4 22.8C6.7 22.8 2 18.1 2 12.4S6.7 2 12.4 2s10.4 4.7 10.4 10.4-4.7 10.4-10.4 10.4Zm19.314 7.56-9.882-9.881a12.368 12.368 0 0 0 2.968-8.08C24.8 5.5 19.2 0 12.4 0 5.5 0 0 5.5 0 12.4s5.5 12.4 12.4 12.4c3.071 0 5.86-1.093 8.015-2.91l9.885 9.886 1.414-1.414ZM12 11V6h2v5h5v2h-5v5h-2v-5H7v-2h5Z",
  fill: "#626262"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }